import {
  MYORDER_FETCH_END,
  MYORDER_FETCH_START, ORDER_CANCEL_REASONS_FETCH, ADULTORDER_FETCH_START, ADULTORDER_FETCH_END,
} from '../constants';

const initialState = {
  isFetchMore: false,
  hasAdultOrder: false,
  hasMore: false,
  list: [],
  nextList: [],
  cancelReasons: {},
};

export default function runtime(state = initialState, action) {
  switch (action.type) {
    case ADULTORDER_FETCH_START:
      return state;

    case ADULTORDER_FETCH_END:
      return Object.assign({}, state, {
        hasAdultOrder: !!(action.data && action.data.length),
      });
    case MYORDER_FETCH_START:
      return Object.assign({}, state, {
        isFetchMore: true,
      })
    /**
     * 翻页过程中，需要知道下一页是否有数据以便知道下一页是否可点击：
     * 第一页加载数据（init）的时候：请求两次，0偏移量和10偏移量（一页10跳数据）。10偏移量存在数据说明有下一页。
     * 点击下一页（next）：请求下页数据去查验是否可以点击下一页，把之前请求好的数据nextList填入当前数据list中完成翻页数据变化。
     * 点击上一页（pre）：请求上一页数据直接请求两次，之所以没有用在点击下一页的时候存储list为preList，
     * 之后点击上一页拿preList去填充一个list的操作，是因为可能有连续点击上一页操作，造成没有提前预备好的preList。
     */
    case MYORDER_FETCH_END:
      switch (action.change) {
        case 'next':
          return Object.assign({}, state, {
            nextList: action.data,
            list: state.nextList,
            hasMore: action.data.length > 0,
            isFetchMore: false,
          });
        case 'pre':
        case 'init':
        default:
          return Object.assign({}, state, {
            list: action.data,
            nextList: action.list,
            hasMore: action.list.length > 0,
            isFetchMore: false,
          });
      }
    case ORDER_CANCEL_REASONS_FETCH:
      return Object.assign({}, state, {
        cancelReasons: action.data,
      })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/myorder.js